module.exports = __webpack_public_path__ + "img/03e_Store_651.4228ed8e.jpg";